import { Box, Button, Grid, Paper, TextField } from "@mui/material";
import React from "react";
import { useUser } from "../contexts/useUser";
import ConversationsList from "./ConversationsList";

const ConversationsAndCallsPage: React.FC = () => {
  const { project } = useUser();

  const [nameFilter, setNameFilter] = React.useState<string | undefined>(
    undefined
  );

  return (
    <>
      <Box p={2}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Paper
              elevation={3}
              style={{ borderRadius: 3, height: 100, border: "1px solid #444" }}
            >
              <Box
                display="flex"
                justifyContent="flex-start"
                alignItems="center"
                height="100%"
              >
                <TextField
                  label="Filter name"
                  variant="outlined"
                  onChange={(e) => setNameFilter(e.currentTarget.value)}
                  value={nameFilter}
                  size="small"
                  sx={{ marginLeft: 2, width: 300 }}
                />

                <Button
                  variant="text"
                  sx={{ marginLeft: 2 }}
                  onClick={() => {
                    setNameFilter("");
                  }}
                >
                  reset
                </Button>
              </Box>
            </Paper>
          </Grid>

          <Grid item xs={12}>
            <Paper
              elevation={3}
              style={{ borderRadius: 3, border: "1px solid #444" }}
            >
              <Box height="100%">
                <ConversationsList
                  projectId={project?.id ?? ""}
                  nameFilter={nameFilter}
                />
                {/*<ConversationsGrid projectId={project?.id ?? ""} nameFilter={nameFilter} />*/}
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default ConversationsAndCallsPage;
